export default () => {
	const ACTIVE_ITEM_SELECTOR = '.js-filter-item.active';
	const ACTIVE_ITEM_CLASS = 'active';
	const filterItems = document.querySelectorAll('.js-filter-item');
	const cards = document.querySelectorAll('.js-collection-card');
	const grid = document.querySelector('.js-product-grid');

	if (!filterItems.length) return;

	filterItems.forEach(item => {
		item.addEventListener('click', () => {
			item.classList.toggle('active');

			if (item.classList.contains('js-apply-onclick')) {
				applyFilters();
			}
		});
	});


	const applyButtons = document.querySelectorAll('.js-apply-filter');
	const clearButtons = document.querySelectorAll('.js-clear-filter');

	applyButtons.forEach(function(button) {
		button.addEventListener('click', (e) => {
			e.preventDefault();

			applyFilters();
		});
	});

	clearButtons.forEach(function(button) {
		button.addEventListener('click', (e) => {
			e.preventDefault();

			clearFilters()
		});
	});


	function applyFilters() {
		const groups = document.querySelectorAll('.js-filter-group');
		let filter = [];

		groups.forEach(function(group) {
			const activeItems = group.querySelectorAll(ACTIVE_ITEM_SELECTOR);
			// console.log({activeItems});
			const type = group.dataset.type;
			let values = [...activeItems].map((itemEl)=>{
				return itemEl.dataset.value
			})

			if (values.length === 0) return;

			let filter_item = {
				type: type,
				values: values,
				activeCount: values.length,
			};

			filter.push(filter_item);
		});
		changeGrid(filter);
		closePopup();
		updateCounters();
	}



	function changeGrid(filter) {
		grid.classList.add('collection-list__container--is-filtered');

		cards.forEach(function(card) {
			let isPassed = true;

			filter.forEach(function(filter_group) {
				let itemArray = card.dataset[filter_group.type].split(', ');
					if (itemArray.length) {
						const intersection = arrayIntersection(itemArray, filter_group.values)
						if (intersection.length == 0) {
							isPassed = false;
						}
					}
			});

			if (isPassed) {
				card.classList.remove('is-hidden');
			} else {
				card.classList.add('is-hidden');
			}
		});
	}

	function clearFilters() {
		const activeItems = document.querySelectorAll(ACTIVE_ITEM_SELECTOR);
		activeItems.forEach(function(item) {
			item.classList.remove(ACTIVE_ITEM_CLASS);
		});

		cards.forEach(function(card) {
			card.classList.remove('is-hidden');
		});

		grid.classList.remove('collection-list__container--is-filtered');
		closePopup();
		updateCounters();
	}

	function closePopup() {
		const popup = document.querySelector('.popup[data-popup="filter"]');
		if (popup) {
			popup.querySelector('.js-close-popup').click();
		}
	}

	function arrayIntersection(arr1, arr2) {
		return arr1.filter(value => arr2.includes(value));
	}

	function sortByPrice(itemSelector) {
		const itemList = Array.from(document.querySelectorAll(itemSelector));
		itemList.sort((a, b) => {
			const priceA = parseFloat(a.querySelector('.card__price').textContent.replace(/[^0-9.]/g, ''));
			const priceB = parseFloat(b.querySelector('.card__price').textContent.replace(/[^0-9.]/g, ''));
			return priceA - priceB;
		});
		itemList.forEach(item => item.parentNode.appendChild(item));
	}



	const plpCards = document.querySelectorAll('.js-collection-card');

	plpCards.forEach(function(card) {
		const price = card.querySelector('.card__price');
		const priceValue = Math.floor(parseFloat(price.textContent.replace(/[^0-9.]/g, '')));
		// card.dataset.price = priceValue;
		card.style.setProperty('--zindex', priceValue);
		card.style.setProperty('--zindex-reversed', -priceValue);
	});



	const sortBtns = document.querySelectorAll('.js-plp-sort');
	sortBtns.forEach(function(btn) {

		btn.addEventListener('click', (e) => {

			if (!btn.classList.contains('active')) {
				sortBtns.forEach(function(b) {
					b.classList.remove('active');
				});
				btn.classList.add('active');
				const sortType = btn.dataset.sort;
				applySort(sortType);
			}

		});
	});

	function updateCounters() {
		const counterTotal = document.querySelector('.js-filter-counter-total');
		const counters = document.querySelectorAll('.filter__parameter .filter__counter');
		const groups = document.querySelectorAll('.js-filter-group');
		const btnClear = document.querySelector('.js-clear-filter');
		let totalCounter = 0;

		groups.forEach(function(group, index) {
			const activeItemsCount = group.querySelectorAll(ACTIVE_ITEM_SELECTOR).length;

			counters[index].textContent = activeItemsCount;
			totalCounter += activeItemsCount;

			if (activeItemsCount) {
				counters[index].classList.add('is-visible');
			} else {
				counters[index].classList.remove('is-visible');
			}
		});


		counterTotal.textContent = totalCounter;
		if (totalCounter) {
			counterTotal.classList.add('is-visible');
			btnClear.classList.add('is-visible');
		} else {
			counterTotal.classList.remove('is-visible');
			btnClear.classList.remove('is-visible');
		}
	}

	function applySort(type) {
		const grid = document.querySelector('.js-product-grid');

		grid.classList.forEach(function(item) {
			if (item.startsWith('is-')) {
				grid.classList.remove(item);
			}
		});


		if (type.length) {
			const className = 'is-' + type;
			grid.classList.add(className);
			// console.log({className});
		} else {
			
		}
	}
}